// ── Types ─────────────────────────────────────────────────────────────────────

export interface LoaderStatus {
  /** '' when nothing is showing; otherwise 'success' or 'error'. */
  status: '' | 'success' | 'error';
  message: string;
}

// ── Action types ──────────────────────────────────────────────────────────────

export const SET_LOADER_STATUS = 'SET_LOADER_STATUS';

export type SetLoaderStatus = {
  type: typeof SET_LOADER_STATUS;
  payload: LoaderStatus;
};

export type UiAction = SetLoaderStatus;

// ── Action creators ───────────────────────────────────────────────────────────

export const setLoaderStatus = (payload: LoaderStatus): SetLoaderStatus => ({
  type: SET_LOADER_STATUS,
  payload,
});

/** Dismiss the banner. Separate creator so call sites read as intent. */
export const clearLoaderStatus = (): SetLoaderStatus =>
  setLoaderStatus({ status: '', message: '' });
